import { Inject, Injectable } from '@angular/core';
import { AnalyticsEvent, AnalyticsEventPayloadMap } from '../models/analytics-event';
import { AnalyticsQueueService } from './analytics-queue.service';
import { AnalyticsConsentService } from './analytics-consent.service';
import { AnalyticsProvider } from '../providers/analytics-provider.interface';
import { ANALYTICS_PROVIDERS } from '../models/analytics.token';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsDispatcherService {

  constructor(
    @Inject(ANALYTICS_PROVIDERS)
    private readonly providers: AnalyticsProvider[],
    private readonly queue: AnalyticsQueueService,
    private readonly consent: AnalyticsConsentService
  ) { }

  /**
   * Dispatches a generic event to all providers
   */
  dispatch(event: AnalyticsEvent, payload?: any) {
    this.queue.push(() => {
      if (!this.consent.hasConsent()) return;

      this.providers.forEach(provider => {
        try {
          provider.dispatch(event, payload);
        } catch (err) {
          console.error('Analytics provider failed', err);
        }
      });
    });
  }

}
